export default __webpack_public_path__ + "static/media/news.73d12fcc.webp";